export const REMOTE_OPTION_ID = 'CustomOption_Remote';
export const OFFICE_OPTION_ID = 'CustomOption_Office';
